module.exports = __webpack_public_path__ + "baa2f30b35859d2ef42fdba95e7f0531.png";